export default {
  auth: () => import("/var/www/frontend/layouts/auth.vue").then(m => m.default || m),
  default: () => import("/var/www/frontend/layouts/default.vue").then(m => m.default || m)
}